export const PRIVACY_POLICY = {
  TITLE_TEXT: 'Privacy Policy',
  SUBTITLE_TEXT: 'Effective from: 7 June 2024',
};
